<template>
  <div class="list">
    <HeaderIndex></HeaderIndex>
    <headNews></headNews>
    <div class="pc" v-if="isPhone == false">
      <div class="container">
        <div class="section1">
          <div class="select">
            <el-select
              v-model="value"
              placeholder="请选择"
              @change="onChange()"
              class="input"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div style="clear: both"></div>
        </div>
        <div class="section2">
          <div class="item" v-for="item in arr" :key="item.url">
            <div>
              <img alt="xxx" :src="item.img" style="width: 100%" />
            </div>
            <div class="content">
              <div class="title">{{ item.title }}</div>
              <div class="text">{{ item.introduction }}</div>
              <div class="botton clickStyle" @click="jump(item.url)">
                查看详情
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ListMobile v-if="isPhone"></ListMobile>
    <FooterIndex></FooterIndex>
  </div>
</template>

<script>
import moment from "moment";
import { csvw_url } from "../../components/config";
import HeaderIndex from "../../components/header-index";
import FooterIndex from "../../components/footer-index";
import ListMobile from "./ListMobile";
import headNews from "../../components/head-news";
export default {
  name: "List",
  components: {
    HeaderIndex,
    FooterIndex,
    headNews,
    ListMobile,
  },
  data() {
    return {
      isPhone: false,
      options: [],
      value: "",
      arr: [],
      arrAll: [],
    };
  },
  mounted: function () {
    // 判断是否手机
    this.getIsPhone();
    this.setTitle();
    this.fetchData();
    this.makeOptions();
  },
  methods: {
    getIsPhone() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.isPhone = true;
        }
      }
    },
    setTitle() {
      document.title = "新闻资讯_专题报道";
    },
    fetchData() {
      this.axios
        .get(`${csvw_url}/front/news/tcDissertation/list`)
        .then((response) => {
          this.makeData(response);
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    },
    makeData(response) {
      let arr = [];
      const dataArr = response.data.data;
      console.log(dataArr);
      for (let item of dataArr) {
        const obj = {};
        obj.title = item.title;
        obj.introduction = item.introduction;
        obj.img = `${csvw_url}${item.picturePath}`;
        obj.attachmentPath = `${csvw_url}${item.attachmentPath}`;
        obj.url = `${item.url}`;
        obj.releaseTime = item.releaseTime;
        arr.push(obj);
      }
      this.arrAll = arr;
      this.onChange();
    },
    onChange() {
      let arr = [];
      if (this.value == "") {
        arr = this.arrAll;
      } else {
        for (let key in this.arrAll) {
          const item = this.arrAll[key];
          let str = moment(item.releaseTime).toString();
          if (str.indexOf(this.value) != -1) {
            arr.push(item);
          }
        }
      }
      this.arr = arr;
    },
    makeOptions() {
      const option = [];
      let start = 2020;
      let end = parseInt(moment().year().toString());
      for (let i = end; i >= start; i--) {
        const obj = {};
        obj.value = `${i}`;
        obj.label = `${i}`;
        option.push(obj);
      }
      option.unshift({
        value: "",
        label: "年",
      });
      this.options = option;
      this.value = "";
    },
    jump(url) {
      window.location.href = url;
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: myCu;
  src: url("../../assets/font/FZYouHJW_Cu.TTF"),
    url("../../assets/font/FZYouHJW_Cu.eot");
  /* IE9+,可以是具体的实际链接 */
}
@font-face {
  font-family: myCuEn;
  src: url("../../assets/font/Proxima-Nova-Bold.otf"),
    url("../../assets/font/Proxima-Nova-Bold.eot");
  /* IE9+,可以是具体的实际链接 */
}

@font-face {
  font-family: myXian;
  src: url("../../assets/font/FZYouHJW_Xian.TTF");
  /* IE9+,可以是具体的实际链接 */
}

@font-face {
  font-family: myZhongXi;
  src: url("../../assets/font/FZYouHJW_ZhongXi.TTF");
  /* IE9+,可以是具体的实际链接 */
}
.list {
  font-family: myZhongXi;
}

.drive {
  position: relative;
  width: 100%;
}
.pc {
  position: relative;
  width: 100%;
}
.clickStyle {
  cursor: pointer;
}
.container {
  position: relative;
  width: 100%;
}

@media screen and (min-width: 1px) {
  .section1 {
    position: relative;
    padding-left: 200px;
    padding-right: 200px;
    margin-top: 10px;
  }
  .input {
    width: 180px;
  }
  .select {
    position: relative;
    float: right;
  }
  .section2 {
    position: relative;
    padding-left: 200px;
    padding-right: 200px;
    padding-bottom: 110px;
  }
  .section2 .item {
    position: relative;
    margin-top: 50px;
  }
  .section2 .content {
    position: absolute;
    width: 800px;
    height: 400px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 10px;
    top: 50%;
    margin-top: -240px;
    left: 50%;
    margin-left: -440px;
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 80px;
  }
  .section2 .content .title {
    font-size: 50px;
    line-height: 36px;
    color: rgba(255, 255, 255, 1);
    font-weight: bold;
    text-align: center;
    margin-top: 20px;
  }
  .section2 .content .text {
    font-size: 20px;
    line-height: 36px;
    color: rgba(255, 255, 255, 1);
    margin-top: 35px;
  }
  .section2 .content .botton {
    position: relative;
    font-size: 20px;
    line-height: 36px;
    color: rgba(255, 255, 255, 1);
    margin-top: 60px;
    border: 1px solid rgba(255, 255, 255, 1);
    border-radius: 5px;
    left: 50%;
    width: 150px;
    margin-left: -75px;
    text-align: center;
  }
}

@media screen and (min-width: 1px) and (max-width: 1300px) {
  .section1 {
    position: relative;
    padding-left: 130px;
    padding-right: 130px;
    padding-bottom: 0px;
    margin-top: 10px;
  }
  .input {
    width: 120px;
  }
  .select {
    position: relative;
    float: right;
  }
  .section2 {
    position: relative;
    padding-left: 130px;
    padding-right: 130px;
    padding-bottom: 70px;
  }
  .section2 .item {
    margin-top: 37px;
  }
  .section2 .content {
    position: absolute;
    width: 540px;
    height: 270px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 7px;
    top: 50%;
    margin-top: -165px;
    left: 50%;
    margin-left: -305px;
    padding-left: 35px;
    padding-right: 35px;
    padding-top: 58px;
  }
  .section2 .content .title {
    font-size: 34px;
    line-height: 24px;
    color: rgba(255, 255, 255, 1);
    font-weight: bold;
    text-align: center;
    margin-top: 20px;
  }
  .section2 .content .text {
    font-size: 14px;
    line-height: 24px;
    color: rgba(255, 255, 255, 1);
    margin-top: 24px;
  }
  .section2 .content .botton {
    position: relative;
    font-size: 14px;
    line-height: 24px;
    color: rgba(255, 255, 255, 1);
    margin-top: 34px;
    border: 1px solid rgba(255, 255, 255, 1);
    border-radius: 7px;
    left: 50%;
    width: 100px;
    margin-left: -50px;
    text-align: center;
  }
}

@media screen and (min-width: 1301px) and (max-width: 1600px) {
  .section1 {
    position: relative;
    padding-left: 160px;
    padding-right: 160px;
    margin-top: 10px;
  }
  .input {
    width: 150px;
  }
  .select {
    position: relative;
    float: right;
  }
  .section2 {
    position: relative;
    padding-left: 160px;
    padding-right: 160px;
    padding-bottom: 90px;
  }
  .section2 .item {
    margin-top: 60px;
  }
  .section2 .content {
    position: absolute;
    width: 660px;
    height: 330px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 8px;
    top: 50%;
    margin-top: -200px;
    left: 50%;
    margin-left: -370px;
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 70px;
  }
  .section2 .content .title {
    font-size: 42px;
    line-height: 30px;
    color: rgba(255, 255, 255, 1);
    font-weight: bold;
    text-align: center;
    margin-top: 20px;
  }
  .section2 .content .text {
    font-size: 17px;
    line-height: 30px;
    color: rgba(255, 255, 255, 1);
    margin-top: 30px;
  }
  .section2 .content .botton {
    position: relative;
    font-size: 17px;
    line-height: 30px;
    color: rgba(255, 255, 255, 1);
    margin-top: 40px;
    border: 1px solid rgba(255, 255, 255, 1);
    border-radius: 5px;
    left: 50%;
    width: 126px;
    margin-left: -63px;
    text-align: center;
  }
}
</style>